/**
 * In-page sections the landing links to (footer sitemap + ⌘K palette). Each `id`
 * is both the anchor target and the scrollspy observation target, so the section
 * stubs in the landing must render elements with matching ids. Lives in its own
 * data module (not the retired marketing header) so the landing page and the
 * command palette share one source without re-introducing header chrome.
 *
 * The display label for each id is localized copy, not data: it lives in
 * `common.nav.sections.<id>` and every consumer (navbar, drawer, footer, ⌘K
 * palette) translates it there (ADR-074).
 */
export const navSections = [
	{ id: 'work' },
	{ id: 'services' },
	{ id: 'pricing' },
	{ id: 'faq' },
] as const
